import { useId } from 'react'
import { Form, useSearchParams, useSubmit } from 'react-router'
import { useDebounce, useIsPending } from '#app/utils/misc.tsx'
import { Icon } from './ui/icon.tsx'
import { Input } from './ui/input.tsx'
import { Label } from './ui/label.tsx'
import { StatusButton } from './ui/status-button.tsx'

export function SearchBar({
	status,
	autoFocus = false,
	autoSubmit = false,
	compact = false,
}: {
	status: 'idle' | 'pending' | 'success' | 'error'
	autoFocus?: boolean
	autoSubmit?: boolean
	compact?: boolean
}) {
	const id = useId()
	const [searchParams] = useSearchParams()
	const submit = useSubmit()
	const isSubmitting = useIsPending({
		formMethod: 'GET',
		formAction: '/users',
	})

	const handleFormChange = useDebounce(async (form: HTMLFormElement) => {
		await submit(form)
	}, 400)

	return (
		<Form
			method="GET"
			action="/users"
			className={
				compact
					? 'flex items-center gap-1'
					: 'flex flex-wrap items-center justify-center gap-2'
			}
			onChange={(e) => autoSubmit && handleFormChange(e.currentTarget)}
		>
			<div className="flex-1">
				<Label htmlFor={id} className="sr-only">
					Etsi
				</Label>
				<Input
					type="search"
					name="search"
					id={id}
					defaultValue={searchParams.get('search') ?? ''}
					placeholder="Hae ratoja..."
					className={compact ? 'h-9 w-full text-sm' : 'w-full'}
					autoFocus={autoFocus}
				/>
			</div>
			<div>
				<StatusButton
					type="submit"
					variant="outline"
					status={isSubmitting ? 'pending' : status}
					className={
						compact
							? 'flex h-9 items-center justify-center px-2.5'
							: 'flex w-full items-center justify-center'
					}
				>
					<Icon name="magnifying-glass" size={compact ? 'sm' : 'md'} />
					<span className="sr-only">Search</span>
				</StatusButton>
			</div>
		</Form>
	)
}
